import { schema } from 'normalizr';

export const lfpGameSchema = new schema.Entity('lfpGames', {}, { idAttribute: 'day' });
export const lfpGameListSchema = [ lfpGameSchema ];



// WEBPACK FOOTER //
// ./src/schemas/lfpGame.js